// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var statusStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-table-cell-content-wrap, .pm-table-header-content-wrap, [data-layout-section]': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap': {
      maxWidth: '100%',
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      lineHeight: 0,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '& > span': {
        width: '100%'
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.statusView-content-wrap': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& > span': {
      cursor: 'pointer',
      // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
      lineHeight: 0 // Prevent responsive layouts increasing height of container.
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.danger': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.status-lozenge-span > span': {
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
      backgroundColor: 'rgba(255, 189, 173, 0.5)' // akEditorDeleteBackgroundWithOpacity
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.statusView-content-wrap.ak-editor-selected-node': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.status-lozenge-span > span': {
        boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)")
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-neutral, #0515240F)",
    maxWidth: '100%',
    paddingInline: "var(--ds-space-050, 4px)",
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    blockSize: 'min-content',
    position: 'static',
    overflow: 'hidden',
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] .lozenge-text': {
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '11px',
    fontStyle: 'normal',
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    maxWidth: "calc(200px - ".concat("var(--ds-space-100, 8px)", ")")
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var statusStylesMixin_fg_platform_component_visual_refresh = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.statusView-content-wrap': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-selected-node .status-lozenge-span > span': {
      boxShadow: "0 0 0 2px ".concat("var(--ds-border-selected, #1868DB)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] .lozenge-text': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    color: '#292A2E'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#DDDEE1'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#D8A0F7'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#8FB8F6'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#F9C84E'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#FD9891'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#B3DF72'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var statusStylesMixin_fg_platform_component_visual_refresh_with_search_match = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '.statusView-content-wrap:not(.search-match-block)': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-selected-node .status-lozenge-span > span': {
      boxShadow: "0 0 0 2px ".concat("var(--ds-border-selected, #1868DB)")
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] .lozenge-text': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    color: '#292A2E'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=neutral] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#DDDEE1'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=purple] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#D8A0F7'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=blue] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#8FB8F6'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=yellow] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#F9C84E'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=red] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#FD9891'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=green] > .lozenge-wrapper': {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: '#B3DF72'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var statusDangerStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '.statusView-content-wrap:not(.search-match-block)': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-selected-node.danger .status-lozenge-span > span': {
      boxShadow: "0 0 0 2px ".concat("var(--ds-border-danger, #E2483D)")
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var statusStylesMixin_without_fg_platform_component_visual_refresh = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.statusView-content-wrap': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-selected-node .status-lozenge-span > span': {
      // getSelectionStyles([SelectionStyle.BoxShadow]);
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)"),
      borderColor: 'transparent',
      // hideNativeBrowserTextSelectionStyles
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&::selection, & *::selection': {
        backgroundColor: 'transparent'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&::-moz-selection, & *::-moz-selection': {
        backgroundColor: 'transparent'
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-neutral, #0515240F)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
    color: "var(--ds-text-subtle, #505258)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
    color: "var(--ds-text-discovery, #803FA5)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-information, #E9F2FE)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
    color: "var(--ds-text-information, #1558BC)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-warning, #FFF5DB)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
    color: "var(--ds-text-warning, #9E4C00)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-danger, #FFECEB)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
    color: "var(--ds-text-danger, #AE2E24)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-success, #EFFFD6)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
    color: "var(--ds-text-success, #4C6B1F)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
  '.statusView-content-wrap:not(.search-match-block)': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.ak-editor-selected-node .status-lozenge-span > span': {
      // getSelectionStyles([SelectionStyle.BoxShadow]);
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-selected, #1868DB)"),
      borderColor: 'transparent',
      // hideNativeBrowserTextSelectionStyles
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&::selection, & *::selection': {
        backgroundColor: 'transparent'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
      '&::-moz-selection, & *::-moz-selection': {
        backgroundColor: 'transparent'
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-neutral, #0515240F)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=neutral] .lozenge-text': {
    color: "var(--ds-text-subtle, #505258)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-discovery, #F8EEFE)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=purple] .lozenge-text': {
    color: "var(--ds-text-discovery, #803FA5)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-information, #E9F2FE)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=blue] .lozenge-text': {
    color: "var(--ds-text-information, #1558BC)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-warning, #FFF5DB)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=yellow] .lozenge-text': {
    color: "var(--ds-text-warning, #9E4C00)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-danger, #FFECEB)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=red] .lozenge-text': {
    color: "var(--ds-text-danger, #AE2E24)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-wrapper': {
    backgroundColor: "var(--ds-background-success, #EFFFD6)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '[data-prosemirror-node-name="status"] > [data-color=green] .lozenge-text': {
    color: "var(--ds-text-success, #4C6B1F)"
  }
});